import * as React from "react";
import { CSSTransition } from "react-transition-group";

import "./FadeIn.scss";

type Props = {
  show: boolean;
  children: React.ReactNode;
};

const FadeIn = ({ show, children }: Props) => (
  <CSSTransition
    in={show}
    classNames="FadeIn"
    mountOnEnter
    unmountOnExit
    timeout={400}
  >
    {children}
  </CSSTransition>
);

export default FadeIn;
